import { render, staticRenderFns } from "./infodetail.vue?vue&type=template&id=55410aec&scoped=true"
import script from "./infodetail.vue?vue&type=script&lang=js"
export * from "./infodetail.vue?vue&type=script&lang=js"
import style0 from "./infodetail.vue?vue&type=style&index=0&id=55410aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55410aec",
  null
  
)

export default component.exports